import React from 'react'
import PropTypes from 'prop-types'
import history from '../../../../core/history'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AdministratorsList from '../AdministratorsList/AdministratorsList'
import {
  actions
} from './administratorsContainerActions'
import Spinner from '../../../../common/Spinners/Spinner'

class AdministratorsContainer extends React.Component {
  static propTypes = {
    administrators: PropTypes.array.isRequired,
    fetchingAdministrators: PropTypes.bool.isRequired,
    submitAdministrator: PropTypes.bool.isRequired,
    submittingAdministrator: PropTypes.bool.isRequired,
    submittedAdministrator: PropTypes.bool.isRequired,
    administratorIndex: PropTypes.number.isRequired,

    fetchAdministrators: PropTypes.func.isRequired,
    toggleAdministratorActive: PropTypes.func.isRequired,
    submitAdministratorActive: PropTypes.func.isRequired
  }

  componentDidMount () {
    this.props.fetchAdministrators()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.submitAdministrator && this.props.submitAdministrator) {
      const { administrators, administratorIndex } = this.props;
      this.props.submitAdministratorActive(
        administrators[administratorIndex]
      );
    }
  }

  addAdministrator () {
    history.push('/administration/administrators/add')
  }

  render () {
    if (this.props.fetchingAdministrators) {
      return <Spinner />
    }else{
      var admins = this.props.fetchAdministrators
    }

    return <AdministratorsList
      administrators={this.props.administrators}
      toggleAdminActive={this.props.toggleAdministratorActive}
      submitting={this.props.submittingAdministrator}
      submitted={this.props.submittedAdministrator}
      addAdmin={this.addAdministrator}
      updateIndex={this.props.administratorIndex}
    />
  }
}

const mapStateToProps = ({ administrators }) => {
  return {
    administrators: administrators.administrators,
    fetchingAdministrators: administrators.fetchingAdministrators,
    submitAdministrator: administrators.submitAdministrator,
    submittingAdministrator: administrators.submittingAdministrator,
    submittedAdministrator: administrators.submittedAdministrator,
    administratorIndex: administrators.administratorIndex
  }
}

const mapDispatchToProps = (dispatch) => {
  const { load, setting, submit } = actions
  return bindActionCreators({
    fetchAdministrators: load.fetchAdministrators,
    toggleAdministratorActive: setting.toggleAdministratorActive,
    submitAdministratorActive: submit.submitAdministratorActive
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdministratorsContainer)
